export default "__VITE_ASSET__DTX99pRM__"